import { createFileRoute } from "@tanstack/react-router";

import Statements from "@/features/statements/Statements";

export const Route = createFileRoute("/_auth/statements")({
  component: Statements,
});
